import React, { createContext, useContext, useState, useEffect } from 'react';
import sq from '../i18n/sq';
import en from '../i18n/en';
import de from '../i18n/de';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'fletaime_lang';
const DICTIONARIES = { sq, en, de };
export const LANGUAGES = ['sq', 'en', 'de'];

const loadLang = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return LANGUAGES.includes(raw) ? raw : 'sq';
  } catch {
    return 'sq';
  }
};

// {emri} placeholders in dictionary strings are filled from params.
const interpolate = (text, params) => {
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match
  );
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(loadLang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  // Fallback chain: active language → Albanian → the key itself, so a
  // missing translation shows Albanian text rather than a blank.
  const t = (key, params) => {
    const text = DICTIONARIES[lang][key] ?? sq[key] ?? key;
    return interpolate(text, params);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
